import { ActivityTypeEnum } from '@sport-activities/sdk';

export function getActivityDetailRouteName(
  type: string,
  sku: number | string
): string {
  if (type === ('LIVE' as ActivityTypeEnum)) {
    return `/attendee.show-live-activity/${sku}`;
  }

  return `/attendee.show-activity/${sku}`;
}
